module.exports = __webpack_public_path__ + "static/media/alex_pcr_product_a.9873be7f.svg";